module.exports = __webpack_public_path__ + "static/img/Bachelor_010293.a1cf5b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010293.jpg
// module id = 141
// module chunks = 0